export default {
  deTopic: {
    derivative: {
      t0: "您通過哪種方式了解衍生品？",
      t1: "了解",
      t2: "不了解",
      t3: "無法開戶，請先了解衍生品知識。",
      t4: "可選擇以下任意一項",
      t5: "1、已接受有關的培訓或課程（可多選）",
      t6: "監管機構",
      t7: "交易所",
      t8: "大專院校",
      t9: "進修學院",
      t10: "金融機構",
      t11: "2、於經濟公司或銀行、基金或資產管理公司、監管機構 或交易所等金融機構有關的工作經驗（可多選）",
      t12: "受監管持牌人士",
      t13: "管理層",
      t14: "與衍生工具相關活動",
      t15: "3、於過去三年內進行了五次或以上有關任何衍生產品之交易(不論是否在交易所買賣)",
      t16: "是",
      t17: "否",
      t18: "請上傳所選項的相關憑證",
      t19: "提示：請根據實際情況提供相關憑證，有助於我們給您提供更好的服務和體驗",
      t20: "客戶在六個月內的財務狀況是否有重大更改? (例如: 破產或清盤等)",
      t21: "是",
      t22: "否",
      t23: "請提供日期及詳情",
      t24: "請輸入...",
      t25: "客戶是否該帳戶之最終實益擁有人？",
      t26: "本公司不接受此類型用戶開戶",
      t27: "是",
      t28: "否",
      t29: "申請原因",
      t30: "請輸入...",
      t31: "* 號必填",
      t32: "客戶確認及承諾",
      t33: "倘簽署本部份，客戶即聲明、同意及確認：",
      t34: "本人之前在高盈證券開立的户口資料己更改。附上更改帳戶資料表格。",
      t35: "本人聲明之前在高盈證券開立的户口資料沒有任何更改，亦同意高盈證券的條款及條件均與上述現有帳戶相同，包括授權操作帳戶之安排。",
      t36: "1.在不抵觸當地適用法律的情況下，本人同意高盈證券可向國內及海外的監管機構或稅務機構提供本人的資料以確立本人於任何司法管轄區的稅務責任。",
      t37: "2.因應國內或海外的監管機構或稅務機構需要，本人准許並同意高盈證券可按適用的法律、法規和指令在本人帳戶中扣留相關所須的金額款項。",
      t38: "本人謹此明確地、無條件地及不可取消地放棄本人因高盈證券因應國內或海外的監管機構或稅務機構需要而在本人帳戶中扣留相關所須的金額款項所發生的損失的索賠權利，及本人須賠償予高盈證券因此而引起的法律責任。",
      t39: "3. 本人保證所提供的任何資料如有變更，需於三十日內通知高盈證券。",
      t40: "聲明",
      t41: "1. 倘若之前在高盈證券開立的戶口資料沒有任何更改，本人同意將原於高盈證券之現有帳戶之資料用作開設額外帳戶之用。",
      t42: "2. 倘若之前在高盈證券開立的戶口資料己更改, 本人同意在高盈證券的要求下，本人將提供己更改資料的相關證明文件予高盈證券作更改現有帳戶資料及開設額外帳戶之用。",
      t43: "3. 本人證實已收取閱讀及明白 證券/ 期貨交易帳戶條款及條件(條款及條件)包括有關隱私政策及客戶協議。",
      t44: "4. 高盈證券有權在任何時間以書面通知更改條款及條件，除非高盈證券收到本人終止帳戶通知，否則表示本人接受該更改條款及條件。",
      t45: "5. 本人現聲明及確認已獲得並完全瞭解按照本人選擇的語言之風險披露聲明，本人已獲邀閱讀及簽署風險披露聲明，如有疑問可徵求獨立意見。",
      t46: "6. 本人/吾等明白高盈證券有最終接納開立額外帳戶與否之權利。",
      t47: "本人/吾等同意输入登录密码确认签名同时用于现有客户加开额外交易账户申请表、开户申请表、衍生产品基本知识课程、W-8BEN表格、风险承受能力问卷、风险披露声明、客户常设授权、税务居民数据、FATCA、投资者识别及场外证券汇报制度之客户资料收集声明和其他适用文件。",
      t48: "本人/吾等同意输入登录密码确认签名同时用于现有客户加开额外交易账户申请表、帳戶資料更改表格、开户申请表、衍生产品基本知识课程、W-8BEN表格、风险承受能力问卷、风险披露声明、客户常设授权、税务居民数据、FATCA、投资者识别及场外证券汇报制度之客户资料收集声明和其他适用文件。",
      t49: "我知道了",
      t50: "開始處理",
      t51: "如需開通額外交易帳號，請聯繫客服"
    }
  },
  treemap:{
    t0: "港股",
    t1: "美股",
    t2: "行情延遲至少15分鐘",
    t3: "熱力圖"
  }
};
